import { ArrowLeft } from "lucide-react";

export default function POSHeader({ title, onBack, icon: Icon, rightContent }) {
  return (
    <div className="bg-emerald-600 text-white px-4 py-3 flex items-center gap-3 shadow-md flex-shrink-0">
      {onBack && (
        <button onClick={onBack} className="w-8 h-8 rounded-lg bg-white/20 flex items-center justify-center hover:bg-white/30 active:scale-95 transition" data-testid="pos-back-btn">
          <ArrowLeft className="w-4 h-4" />
        </button>
      )}
      {Icon && <Icon className="w-5 h-5" />}
      <h1 className="text-base font-bold flex-1">{title}</h1>
      {rightContent}
    </div>
  );
}
